import { useId } from 'react';

/**
 * Octo logomark'ı (marka kılavuzu: Octo_App-Logo → Brandmark, tam renkli).
 *
 * Vektör olarak gömülü: 1,4 KB'lık tek bir yol, ayrı bir ağ isteği gerektirmiyor ve her
 * boyutta keskin duruyor. Gradyan uçları logonun kendi renkleri — tema değişse de logo
 * değişmez, markanın rengi temadan bağımsızdır.
 *
 * Boşluklar (ahtapot kolları) bilerek şeffaf: logo zeminin üstünde oyulmuş duruyor, marka
 * kılavuzundaki "full colour" kullanım da böyle.
 */
export function OctoMark({ className, title }: { className?: string; title?: string }) {
  // Aynı sayfada birden fazla logo olabiliyor (başlık + giriş kartı); gradyan kimliği
  // benzersiz olmazsa tarayıcı ilk tanımı kullanır ve kopyalar bozulur.
  const id = useId();
  return (
    <svg
      viewBox="0 0 260 260"
      className={className}
      role="img"
      aria-label={title ?? 'Octo'}
      aria-hidden={title ? undefined : true}
    >
      <defs>
        <linearGradient id={id} x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="var(--brand-gradient-to)" />
          <stop offset="1" stopColor="var(--brand-gradient-from)" />
        </linearGradient>
      </defs>
      <g transform="translate(0,260) scale(0.1,-0.1)" fill={`url(#${id})`}>
        <path
          d="M1218 2385 c-1 -1 -25 -5 -53 -8 -139 -15 -330 -79 -403 -135 l-24
-18 79 -46 c105 -61 190 -121 289 -205 44 -37 121 -102 171 -144 229 -193 410
-287 558 -290 57 -1 112 8 244 42 63 17 124 28 136 25 35 -9 44 -43 29 -114
-19 -92 -78 -181 -151 -229 -17 -12 -21 -21 -16 -44 9 -44 -5 -78 -40 -99 -48
-30 -83 -26 -122 13 -33 33 -35 34 -84 23 -44 -9 -51 -13 -51 -34 0 -37 -52
-82 -94 -82 -42 0 -94 42 -99 80 -2 14 -8 25 -13 25 -5 1 -30 4 -55 8 -43 7
-49 6 -77 -23 -42 -42 -92 -42 -134 0 -27 28 -30 36 -26 79 5 45 3 48 -34 75
-37 26 -40 27 -57 12 -44 -40 -117 -22 -147 36 -13 26 -14 38 -5 70 11 36 10
41 -11 59 -67 56 -253 167 -264 156 -4 -4 12 -43 81 -202 7 -16 30 -70 50
-119 106 -250 236 -427 362 -494 53 -28 208 -72 311 -88 57 -9 85 -43 70 -84
-14 -41 -95 -123 -145 -149 -93 -47 -214 -59 -353 -36 -42 6 -47 5 -59 -17 -7
-14 -27 -30 -44 -36 -71 -25 -131 18 -132 94 0 40 -3 46 -35 65 -19 12 -45 30
-56 41 -21 19 -23 19 -54 3 -67 -35 -142 9 -144 84 0 29 5 47 21 62 l22 22
-27 54 c-22 44 -31 53 -52 51 -51 -3 -70 3 -95 27 -26 26 -27 30 -27 65 0 41
3 48 27 71 13 13 25 28 25 33 0 5 -12 35 -26 67 -24 52 -30 58 -48 52 -93 -32
-176 74 -117 149 l19 24 -42 44 c-23 25 -49 51 -57 57 -18 15 -16 25 -22 -112
-22 -515 313 -966 813 -1096 152 -40 351 -45 500 -13 57 13 237 78 270 99 19
12 42 24 50 27 35 13 180 130 242 196 192 204 289 449 291 732 2 249 -67 462
-210 655 -175 236 -408 376 -713 430 -38 7 -236 15 -242 10z"
        />
      </g>
    </svg>
  );
}
